import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import DeviceDetectionContext from '~/context/giveaway/DeviceDetectionContext';
import { fetchDeviceDetection } from '~/services/common';
import { generateErrorLogger } from '~/utilities/loggers';

function useFetchDeviceDetection() {
  const {
    deviceDetection: { setData, setError }
  } = useContext(DeviceDetectionContext);

  useEffectWithController(
    controller => {
      fetchDeviceDetection(navigator.userAgent, controller)
        .then(({ data }) => {
          setData(data);
        })
        .catch(
          generateErrorLogger(
            'Get Device Detection',
            {},
            { callback: setError, controller }
          )
        );
    },
    [setData, setError]
  );
}

export default useFetchDeviceDetection;
